import axios from 'axios'
import Qs from 'qs'
import { getToken, setToken, getAuthMeta, setAuthMeta, clearAuthSession } from './auth'

const http = axios.create({
  timeout: 300000
})

let ticketRefreshPromise = null
let authExpiredNotified = false

function emitAuthExpired (embedded, message) {
  if (authExpiredNotified) return
  authExpiredNotified = true
  const detail = { embedded: embedded, message: message || '登录已失效' }
  let event
  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent('wpc-h5-auth-expired', { detail: detail })
  } else {
    event = document.createEvent('CustomEvent')
    event.initCustomEvent('wpc-h5-auth-expired', false, false, detail)
  }
  window.dispatchEvent(event)
}

function renewTicketSession (authMeta) {
  if (ticketRefreshPromise) return ticketRefreshPromise
  const refreshRequest = axios.post(
    process.env.API_BASE_URL + '/h5/auth/ticketLogin',
    Qs.stringify({
      ticket: authMeta.ticket,
      channel: authMeta.channel || '',
      envKey: authMeta.envKey || '',
      fromWechat: /micromessenger/i.test(window.navigator.userAgent || '') ? '1' : '0'
    }),
    {
      timeout: 300000,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }
  ).then(response => {
    const res = response.data || {}
    const data = res.data || {}
    const accessToken = data.accessToken || data.access_token || ''
    if (res.result !== '1' || !accessToken) {
      throw new Error(res.desc || '登录已失效')
    }
    setToken(accessToken)
    setAuthMeta(Object.assign({}, authMeta, {
      envKey: data.envKey || authMeta.envKey || '',
      authMode: data.authMode || authMeta.authMode || '',
      externalUserId: data.externalUserId || authMeta.externalUserId || '',
      source: data.source || authMeta.source || '',
      userId: data.userId || authMeta.userId || '',
      userName: data.userName || authMeta.userName || '',
      trueName: data.trueName || authMeta.trueName || '',
      phone: data.phone || authMeta.phone || '',
      idCard: data.idCard || authMeta.idCard || ''
    }))
    authExpiredNotified = false
    return accessToken
  })
  ticketRefreshPromise = refreshRequest.then(accessToken => {
    ticketRefreshPromise = null
    return accessToken
  }, error => {
    ticketRefreshPromise = null
    throw error
  })
  return ticketRefreshPromise
}

http.interceptors.request.use(config => {
  config.baseURL = process.env.API_BASE_URL
  config.headers.Authorization = getToken()
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  return config
})

http.interceptors.response.use(
  response => {
    if (getToken()) authExpiredNotified = false
    return response.data
  },
  error => {
    const response = error.response
    const originalRequest = error.config || {}
    if (response && response.status === 401) {
      const authMeta = getAuthMeta()
      const canRenewByTicket = !!authMeta.ticket && authMeta.authMode !== 'password'
      if (!originalRequest._authRetry && !originalRequest.skipAuthRecovery && canRenewByTicket) {
        originalRequest._authRetry = true
        return renewTicketSession(authMeta).then(accessToken => {
          originalRequest.headers = originalRequest.headers || {}
          originalRequest.headers.Authorization = accessToken
          return http(originalRequest)
        }).catch(refreshError => {
          clearAuthSession()
          emitAuthExpired(true, refreshError.message || '登录已失效，请重新进入小程序页面')
          return Promise.reject(refreshError)
        })
      }
      clearAuthSession()
      emitAuthExpired(canRenewByTicket, canRenewByTicket
        ? '登录已失效，请重新进入小程序页面'
        : '登录已过期，请重新登录')
    }
    if (response && response.data) {
      const data = response.data || {}
      const backendMessage = data.desc || data.message || data.msg || ''
      if (backendMessage) {
        const wrappedError = new Error(backendMessage)
        wrappedError.response = response
        wrappedError.originalError = error
        return Promise.reject(wrappedError)
      }
    }
    return Promise.reject(error)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js